import { initTracking, initMParticle, initPostHog } from '@rebtel/rebtel-web-tracking'

// Boots the shared tracking layer (mParticle + PostHog). Imported once from
// main.js before the app mounts. Replaces the hand-rolled mParticle snippet
// that used to live in App.vue.
initTracking({
  techPlatform: 'my-rebtel',
  gtmMeasurementId: process.env.GTM_ID,
  cookieDomain: process.env.COOKIE_DOMAIN,
  debug: process.env.MP_DEV_MODE === true,
  mparticle: {
    apiId: process.env.MPARTICLE_API_ID,
    workspaceToken: process.env.MPARTICLE_WORKSPACE_TOKEN,
    dataPlanId: 'client_web',
    proxyUrls: {
      v1Secure: 'mp.rebtel.com/webevents/v1/JS/',
      v2Secure: 'mp.rebtel.com/webevents/v2/JS/',
      v3Secure: 'mp.rebtel.com/webevents/v3/JS/',
      config: 'mp.rebtel.com/tags/JS/v2/',
      identity: 'mp.rebtel.com/identity/v1/',
      alias: 'mp.rebtel.com/webevents/v1/identity/'
    },
    isDevMode: process.env.MP_DEV_MODE === true,
    // Remove Application State Transition (AST) events except first-run ones,
    // which server-side integrations use to mark an install.
    onCreateBatch: (batch) => {
      batch.events = batch.events.filter((event) => {
        return event.event_type !== 'application_state_transition' || event.is_first_run
      })
      return batch
    }
  },
  posthog: {
    key: process.env.POSTHOG_KEY,
    apiHost: process.env.POSTHOG_HOST,
    uiHost: 'https://eu.posthog.com'
  },
  adapters: {
    mparticle: process.env.LOAD_MPARTICLE !== false,
    posthog: process.env.POSTHOG_ENABLED === true
  }
})

// Adapter calls made before the SDKs finish initializing are dropped silently
// (no queue in the package), so consumers that fire events at boot must wait
// for this promise. The catch keeps a failed init from also killing every
// later event.
export const trackingReady = Promise.all([initMParticle(), initPostHog()])
  .catch(() => {})



// WEBPACK FOOTER //
// ./src/plugins/tracking.js